import { AppstoreAddOutlined, DeleteOutlined, DownOutlined, EditOutlined } from '@ant-design/icons';
import { Button, Dropdown, Menu, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { type WhatsappLiveChatModuleSpecsFragment } from '../../../../api/fragments/WhatsappLiveChatModuleSpecs';
import { type PermissionValues } from '../../../../utilities/hasPermissions';
import useDeleteModule from '../useDeleteModule';
import { useUpdateWhatsappLiveChatModuleDrawer } from './UpdateWhatsappLiveChatModuleDrawer';
import { useWhatsappLivechatSettingsDrawer } from './WhatsappLiveChatSettingsDrawer';

export type WhatsappLiveChatModuleActionsProps = {
    module: WhatsappLiveChatModuleSpecsFragment;
    permissions: Pick<PermissionValues, 'hasDeletePermission' | 'hasUpdatePermission'>;
};

const WhatsappLiveChatModuleActions = ({ module, permissions }: WhatsappLiveChatModuleActionsProps) => {
    const { t } = useTranslation(['whatsappLiveChatModuleDetails', 'moduleDetails']);
    const drawer = useWhatsappLivechatSettingsDrawer(module.id);
    const updateWhatsappLiveChatModuleDrawer = useUpdateWhatsappLiveChatModuleDrawer(module);
    const deleteModule = useDeleteModule(module.id);
    const { hasUpdatePermission, hasDeletePermission } = permissions;

    const items = [
        hasUpdatePermission && {
            label: t('whatsappLiveChatModuleDetails:mainActionButtons.updateSpecs'),
            key: 'updateSpecs',
            icon: <EditOutlined />,
            onClick: updateWhatsappLiveChatModuleDrawer.open,
        },
        hasUpdatePermission && {
            label: t('whatsappLiveChatModuleDetails:mainActionButtons.addSetting'),
            key: 'addSetting',
            icon: <AppstoreAddOutlined />,
            onClick: drawer.open,
        },
        hasDeletePermission && {
            label: t('whatsappLiveChatModuleDetails:mainActionButtons.delete'),
            key: 'delete',
            icon: <DeleteOutlined />,
            onClick: deleteModule,
            danger: true,
        },
    ].filter(Boolean);

    if (!items.length) {
        return null;
    }

    return (
        <>
            <Dropdown overlay={<Menu items={items} />}>
                <Button type="primary">
                    <Space>
                        <span>{t('whatsappLiveChatModuleDetails:mainActionButtons.actions')}</span>
                        <DownOutlined />
                    </Space>
                </Button>
            </Dropdown>
            {drawer.render()}
            {updateWhatsappLiveChatModuleDrawer.render()}
        </>
    );
};

export default WhatsappLiveChatModuleActions;
